import React from "react";
import useSearchState from "../useSearchState";
import { searchType } from "../../common/types/search/search";

interface SearchesActionsSaveButtonProps {
	updateSearch: (current: searchType, currentInput) => void;
	current: searchType;
}

export const SearchesActionsSaveButton = ({
	updateSearch,
	current,
}: SearchesActionsSaveButtonProps) => {
	const { currentInput } = useSearchState();

	const handleSaveSearchClick = () => {
		updateSearch(current, currentInput.toJS());
	};

	return (
		<button
			type="button"
			className="btn btn--secondary btn--divided btn--has-icon btn--save"
			onClick={handleSaveSearchClick}
		>
			<span>Save...</span>
		</button>
	);
};
